import { useTranslations } from 'use-intl'

import { Marquee } from '@/components/ui/marquee'
import { Reveal } from '@/components/ui/reveal'

const COMPANIES = [
  'allianz',
  'bd',
  'bpce',
  'ca',
  'education-nationale',
  'huillier',
  'la-region',
  'lafayette',
  'marie-blachere',
  'schneider',
]

// Client logos, in their own section below the hero so their spacing never
// shifts the hero's background image.
export function LogosSection() {
  const t = useTranslations('home.logos')
  return (
    <section className="mt-8 pb-16 lg:mt-12 lg:pb-24">
      {/* `fade` rather than the full gesture: the marquee already scrolls on
          its own, adding a rise would put two movements on top of each other. */}
      <Reveal
        fade
        className="relative mx-auto max-w-7xl px-6 [container-type:inline-size] lg:px-8"
      >
        <h2 className="mb-6 text-center font-mono text-xs font-medium tracking-[0.08em] text-muted-foreground uppercase lg:text-sm">
          {t('title')}
        </h2>
        <Marquee pauseOnHover className="[--duration:40s] [--gap:0px]">
          {COMPANIES.map((logo) => (
            // Slots sized in container-query units → 8 logos fit the container on desktop.
            <div
              key={logo}
              className="flex w-[calc(100cqw/3)] shrink-0 items-center justify-center px-2 sm:w-[calc(100cqw/5)] sm:px-5 lg:w-[calc(100cqw/8)]"
            >
              <img
                src={`/companies/${logo}.webp`}
                alt={logo}
                width={90}
                height={90}
                loading="lazy"
                decoding="async"
                className="max-h-20 w-auto max-w-full object-contain opacity-80 grayscale transition duration-300 hover:opacity-100 hover:grayscale-0 sm:max-h-14 lg:max-h-20"
              />
            </div>
          ))}
        </Marquee>
        {/* Fade the marquee edges into the background so logos dissolve smoothly. */}
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-20 bg-gradient-to-r from-background via-background/80 to-transparent sm:w-40" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-20 bg-gradient-to-l from-background via-background/80 to-transparent sm:w-40" />
      </Reveal>
    </section>
  )
}
